import { render, staticRenderFns } from "./ShowBincard.vue?vue&type=template&id=5371814d&scoped=true&"
import script from "./ShowBincard.vue?vue&type=script&lang=ts&"
export * from "./ShowBincard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371814d",
  null
  
)

export default component.exports